import { Box, CircularProgress } from '@mui/material';
import { Suspense } from 'react';
import {
  useGetBenchmarkingQuery,
  useGetBenchmarkOverwriteQuery,
  useGetPortfolioAnalysisHeatQuery,
  useGetPortfolioAnalysisPowerQuery,
  useGetPortfolioAnalysisSubscriptionQuery,
  useGetPortfolioAnalysisWaterQuery,
} from '../../../../api/energy-analysis/portfolioAnalysisApiSlice';
import PortfolioAnalysisManagementDrawer from '@/features/service-management/components/portfolio-analysis/PortfolioAnalysisManagementDrawer';

const PortfolioAnalysisDrawerContainer = ({ isOpen, onClose, account }) => {
  const { data: subscriptionData } = useGetPortfolioAnalysisSubscriptionQuery(
    { recalc_account_id: account.AccountId },
    { skip: !account?.AccountId },
  );

  const { data: powerData } = useGetPortfolioAnalysisPowerQuery(
    { recalc_account_id: account?.AccountId },
    { skip: !account?.AccountId },
  );
  const { data: waterData } = useGetPortfolioAnalysisWaterQuery(
    { recalc_account_id: account?.AccountId },
    { skip: !account?.AccountId },
  );
  const { data: heatData } = useGetPortfolioAnalysisHeatQuery(
    { recalc_account_id: account?.AccountId },
    { skip: !account?.AccountId },
  );

  const { data: benchmarkData } = useGetBenchmarkingQuery(
    { recalc_account_id: account?.AccountId },
    { skip: !account?.AccountId },
  );
  const { data: benchmarkOverwriteData } = useGetBenchmarkOverwriteQuery(
    { account_id: account?.AccountId },
    { skip: !account?.AccountId },
  );

  return (
    <Suspense
      fallback={
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            verticalAlign: 'center',
          }}
        >
          <CircularProgress />
        </Box>
      }
    >
      <PortfolioAnalysisManagementDrawer
        account={{
          ...account,
          jsonObjects: [
            { object: subscriptionData, name: 'Subscriptions' },
            { object: powerData, name: 'Power', nameKey: 'address' },
            { object: waterData, name: 'Water', nameKey: 'address' },
            { object: heatData, name: 'Heat', nameKey: 'address' },
            {
              object: benchmarkData,
              name: 'Benchmark',
              nameKey: 'MatrikelKey',
            },
            {
              object: benchmarkOverwriteData,
              name: 'Benchmark Overwrite',
              nameKey: 'MatrikelKey',
            },
          ],
        }}
        open={isOpen}
        onClose={onClose}
      />
    </Suspense>
  );
};

export default PortfolioAnalysisDrawerContainer;
